"use client";

import type { InputHTMLAttributes } from "react";
import { cn } from "./cn";
import { Field } from "./Field";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  helper?: string;
  error?: string;
}

export function Input({ label, helper, error, required, id, className, ...rest }: InputProps) {
  return (
    <Field label={label} helper={helper} error={error} required={required} htmlFor={id}>
      {({ fieldId, describedBy }) => (
        <input
          id={fieldId}
          className={cn("field-input", className)}
          required={required}
          aria-invalid={Boolean(error) || undefined}
          aria-describedby={describedBy}
          {...rest}
        />
      )}
    </Field>
  );
}
